import pick from 'lodash/pick';
import mapValues from 'lodash/mapValues';

import merge from 'lodash/merge';
import intersection from 'lodash/intersection';
import { createSelector } from 'reselect';

import { getCredentialEntities } from '../entities';

const getSortedCredentials = (state) => state.credentials.sortedIds;

export const getCredentialsByType = createSelector(
  [
    getSortedCredentials,
    (state) => state.credentials.byType,
    (state) => state.credentials.schemas,
    getCredentialEntities,
  ],

  (sortedIds, byType, schemas, credentialEntities) => {
    let entities = merge({}, credentialEntities, schemas);

    let credentialsByType = mapValues(byType, (credIds) => {
      let entitiesOfType = pick(entities, credIds);
      let sortedIdsForThisType = intersection(sortedIds, credIds);
      return { items: entitiesOfType, sortedIds: sortedIdsForThisType };
    });
    return credentialsByType;
  },
);

/**
 * Returns the credential count for a connector type.
 * Handles both shapes:
 *  - Raw Redux state (`state.credentials.byType`): `{ [type]: number[] }`
 *  - Selector output (`getCredentialsByType`): `{ [type]: { sortedIds: number[] } }`
 */
export function getCredentialCount(credentialsByType, type) {
  const entry = credentialsByType?.[type];
  if (!entry) return 0;
  if (Array.isArray(entry)) return entry.length;
  return entry.sortedIds?.length ?? 0;
}
